import  { smoothScrollTo, nativeSmoothScrollTo, default as scrollToElement } from "./smooth-scrolling-poyfill.js";

/**
 * Available configuration parameters are:
 * * duration: duration to scroll to target page in ms (deafult 600)
 * * top: tolerance in px to tell if current scroll position is considered as top position (deafult 30)
 */
export default class ScrollSpy {
    constructor(config = {}) {
        const c = Object.assign({
            top: 30,
            duration: 600,
            pageSelector: null
        }, config);

        this.config = c;

        this.topPosition = c.top;
        this.scrollDuration = c.duration;

        this.pagePositions = [];

        document.querySelectorAll('.page-link').forEach(link => {
            link.addEventListener('click', e => {
                this.onLinkClick(e)
            });
        });

        window.addEventListener('resize', () => {
            this.updatePageHeight();
            this.loadPagePositions();
        });

        window.addEventListener('scroll', e => {
            this.onScroll(e)
        });

        this.updatePageHeight();
        this.loadPositionFromUrl();
        this.loadPagePositions();

        this.onScroll()
    }

    updatePageHeight() {
        if (this.config.pageSelector) {
            let firstHeight = null;
            let height = window.innerHeight;

            const wpAdminBar = document.querySelector('#wpadminbar');

            if (wpAdminBar) {
                const isFixed = window.innerWidth > 600;

                if (isFixed) {
                    height -= wpAdminBar.getBoundingClientRect().height;
                } else {
                    firstHeight = height - wpAdminBar.getBoundingClientRect().height;
                }
            }

            let isFirst = true;
            document.querySelectorAll(this.config.pageSelector).forEach(page => {
                if (firstHeight && isFirst) {
                    page.style.minHeight = firstHeight + 'px'
                } else {
                    page.style.minHeight = height + 'px'
                }

                if (isFirst) {
                    isFirst = false;
                }
            })
        }
    }

    onScroll() {
        const [ x, y ] = this.getScroll();

        if ( y <= this.topPosition ) {
            document.body.classList.add('top');
        } else {
            document.body.classList.remove('top');
        }

        const [ scrollX, scrollY ] = this.getScroll();

        let activePage = null;

        for (let pos in this.pagePositions) {
            pos = parseInt(pos);

            if (null !== activePage && scrollY < pos) {
                break;
            }

            activePage = this.pagePositions[pos];
        }

        this.setTargetToUrl(activePage.target);
        this.setLinkActive(activePage.target);
    }

    onLinkClick(e) {
        let target = e.target;

        if ( ! e.target.hasAttribute('data-target') && e.target.parentNode.hasAttribute('data-target')) {
            target = e.target.parentNode;
        }

        if (target.hasAttribute('data-target')) {
            e.preventDefault();

            const targetPage = target.getAttribute('data-target');
            this.scrollToTarget(targetPage);
        }
    }

    scrollToTarget(target, animate = true) {
        const selector = `[data-page="${target}"]`;
        const page = document.querySelector(selector);

        if ('undefined' !== typeof page && page) {
            smoothScrollTo(page.offsetTop, animate ? this.scrollDuration : 0);
        } else {
            location.href = '/#/' + target;
        }
    }

    scrollToTop(animate = true) {
        smoothScrollTo(0, animate ? this.scrollDuration : 0);
    }

    setLinkActive(target) {
        document.querySelectorAll('.page-link').forEach(link => {
            if (link.hasAttribute('data-target')) {
                if (link.getAttribute('data-target') === target) {
                    link.parentNode.classList.add('current-menu-item');
                } else {
                    link.parentNode.classList.remove('current-menu-item');
                }
            }
        });
    }

    getScroll() {
        if (window.pageYOffset != undefined) {
            return [pageXOffset, pageYOffset];
        } else {
            var sx, sy, d = document,
                r = d.documentElement,
                b = d.body;
            sx = r.scrollLeft || b.scrollLeft || 0;
            sy = r.scrollTop || b.scrollTop || 0;
            return [sx, sy];
        }
    }

    setTargetToUrl(target) {
        location.hash = '/' + target;
    }

    getTargetFromUrl() {
        return location.hash.replace('#/', '')
    }

    loadPositionFromUrl() {
        const pathName = this.getTargetFromUrl();

        if (pathName) {
            this.scrollToTarget(pathName, false);
        } else {
            this.setLinkActive('home');
        }
    }

    loadPagePositions() {
        this.pagePositions = [];

        document.querySelectorAll('.page').forEach(page => {
            if (page.classList.contains('no-scrollspy')) {
                return;
            }
            const top = page.offsetTop;
            this.pagePositions[top] = {
                page: page,
                target: page.getAttribute('data-page')
            }
        });
    }

    gotoNext() {
        const currentMenuItem = document.querySelector('#main-menu .current-menu-item a');

        if (currentMenuItem) {
            const currentTarget = currentMenuItem.getAttribute('data-target');

            let nextTarget = null;

            let useNext = false;
            document.querySelectorAll('.page').forEach(page => {
                if (page.classList.contains('no-scrollspy')) {
                    return;
                }
                if (useNext) {
                    nextTarget = page.getAttribute('data-page');
                    useNext = false;
                }

                if (page.getAttribute('data-page') === currentTarget) {
                    useNext = true;
                }
            });

            if (nextTarget) {
                this.scrollToTarget(nextTarget);
            }
        }
    }
}
